import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { CosmicShell } from "@/components/CosmicShell";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import SearchResults from "@/pages/SearchResults";
import RideDetail from "@/pages/RideDetail";
import PublishRide from "@/pages/PublishRide";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Profile from "@/pages/Profile";
import Dashboard from "@/pages/Dashboard";
import Messages from "@/pages/Messages";
import BusTickets from "@/pages/BusTickets";
import ProvinceExplorer from "@/pages/ProvinceExplorer";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const AppInner = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <CosmicShell>
      <ScrollToTop />
      <Navbar />
      <main className="min-h-[calc(100vh-64px)]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/search" element={<SearchResults />} />
          <Route path="/rides/:rideId" element={<RideDetail />} />
          <Route path="/bus" element={<BusTickets />} />
          <Route path="/explore" element={<ProvinceExplorer />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/profile/:userId" element={<Profile />} />
          <Route path="/publish" element={<ProtectedRoute><PublishRide /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
        </Routes>
      </main>
      <Footer />
      <Toaster position="top-center" richColors theme="dark" />
    </CosmicShell>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <AppInner />
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
